import { Component } from '@angular/core';


export class SkyPagingDemoComponent {
  public currentPage = 1;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-paging-demo',
  template: `<div>
  <sky-paging
    pageSize="2"
    maxPages="3"
    [(currentPage)]="currentPage"
    itemCount="8">
  </sky-paging>
  <span>Current page is {{currentPage}}</span>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
